import { init } from '@sentry/react';
import { BrowserTracing } from '@sentry/browser';

const CLARITY_PROJECT_ID = 'wbg91xm0dv';

const getClarityUserUrl = () => {
    const clckMatch = document.cookie.match(/(?:^|; )_clck=([^;]+)/);

    if (!clckMatch) return null;

    const userId = decodeURIComponent(clckMatch[1]).split('^')[0];

    if (!userId) return null;

    return `https://clarity.microsoft.com/projects/view/${CLARITY_PROJECT_ID}/impressions?UserId=${encodeURIComponent(`is;${userId}`)}`;
};

const sentryLogger = {
    init(environment) {
        if (environment !== 'production') {
            return null;
        }

        init({
            dsn: 'https://ffa4b3f1f254329df275e6eca2359f4b@o1159603.ingest.us.sentry.io/4508449695006721',
            environment,
            integrations: [
                new BrowserTracing()
            ],
            beforeSend(event, hint) {
                const exception = event?.exception?.values?.[0];

                if (exception.value?.startsWith('Non-Error exception captured') ||
                    hint.originalException?.message?.startsWith('Non-Error exception captured')
                ) {
                    return null;
                }

                if (exception && exception.type === 'TypeError' &&
                    exception.value?.includes('undefined is not an object') &&
                    exception.value?.includes('window.webkit.messageHandlers')
                ) {
                    return null;
                }

                if (
                    exception && exception.type === 'AbortError' &&
                    exception.value?.includes('Old view transition aborted by new view transition')
                ) {
                    return null;
                }

                const clarityUserUrl = getClarityUserUrl();

                if (!clarityUserUrl) {
                    return event;
                }

                return {
                    ...event,
                    tags: {
                        ...event.tags,
                        'clarity_user_url': clarityUserUrl
                    }
                };
            },
            tracesSampleRate: 0.05
        });
    }
};

export {
    sentryLogger
};
